// navigation scroll to bar section js
(() => {
  const nav = document.querySelector(".scroll-navigation-row");
  if (!nav) return;

  const OFFSET = 100;
  const getTarget = (href) => {
    if (!href || !href.startsWith("#")) return null;
    try {
      return document.querySelector(href);
    } catch {
      return null;
    }
  };
  nav.addEventListener("click", (e) => {
    const link = e.target.closest("a");
    if (!link) return;

    const target = getTarget(link.getAttribute("href"));
    if (!target) return;

    e.preventDefault();
    const top =
      target.getBoundingClientRect().top + window.pageYOffset - OFFSET;

    window.scrollTo({
      top,
      behavior: "smooth",
    });
    history.pushState(null, "", link.getAttribute("href"));
  });
})();

// ends
